import en from './languages/en';
import zh from './languages/zh';

export const translations = {
  en,
  zh
};
